import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  // onSubmit?: (e: React.FormEvent) => void;
  areaLabeledBy?: string;
  maxWidth?: number;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title = "Modal Title",
  children,
  // onSubmit,
  areaLabeledBy = "Modal",
  maxWidth = 500,
}) => {
  return (
    <>
      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        tabIndex={-1}
        style={{ display: isOpen ? "block" : "none" }}
        aria-modal={isOpen}
        role="dialog"
        aria-labelledby={areaLabeledBy}
        aria-hidden={!isOpen}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: maxWidth }}
        >
          <div className="modal-content">
            {/* <form onSubmit={onSubmit}> */}
            <div className="modal-header">
              <h4 className="modal-title fs-5">{title}</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
            <div className="modal-body">{children}</div>
            {/* </form> */}
          </div>
        </div>
      </div>

      <div
        className={`modal-backdrop fade ${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
      />
    </>
  );
};

export default Modal;
